import { useMemo } from 'react';
import { useOrganization } from './useOrganizations';

export const usePaywallModal = () => {
  const organization = useOrganization();

  const shouldShowPaywall = useMemo(() => {
    // Show paywall if organization exists and paymentStatus is "unpaid"
    return organization?.subscription?.paymentStatus === 'unpaid';
  }, [organization]);

  const invoiceUrl = useMemo(() => {
    return organization?.subscription?.invoiceUrl;
  }, [organization]);

  return {
    shouldShowPaywall,
    invoiceUrl,
  };
};
